var cov_1rk3ztyi43 = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/config.ts",
      hash = "32a8795b6e05aa90a3caffa97e13c4d42068d265",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/config.ts",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 20
        },
        end: {
          line: 7,
          column: 38
        }
      },
      "1": {
        start: {
          line: 23,
          column: 29
        },
        end: {
          line: 35,
          column: 1
        }
      },
      "2": {
        start: {
          line: 40,
          column: 2
        },
        end: {
          line: 40,
          column: 65
        }
      },
      "3": {
        start: {
          line: 40,
          column: 45
        },
        end: {
          line: 40,
          column: 65
        }
      },
      "4": {
        start: {
          line: 41,
          column: 2
        },
        end: {
          line: 41,
          column: 21
        }
      },
      "5": {
        start: {
          line: 45,
          column: 2
        },
        end: {
          line: 47,
          column: 3
        }
      },
      "6": {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 46,
          column: 19
        }
      },
      "7": {
        start: {
          line: 51,
          column: 2
        },
        end: {
          line: 51,
          column: 35
        }
      },
      "8": {
        start: {
          line: 55,
          column: 2
        },
        end: {
          line: 60,
          column: 3
        }
      },
      "9": {
        start: {
          line: 56,
          column: 22
        },
        end: {
          line: 56,
          column: 45
        }
      },
      "10": {
        start: {
          line: 57,
          column: 4
        },
        end: {
          line: 59,
          column: 5
        }
      },
      "11": {
        start: {
          line: 58,
          column: 6
        },
        end: {
          line: 58,
          column: 22
        }
      },
      "12": {
        start: {
          line: 62,
          column: 2
        },
        end: {
          line: 62,
          column: 80
        }
      },
      "13": {
        start: {
          line: 62,
          column: 52
        },
        end: {
          line: 62,
          column: 80
        }
      },
      "14": {
        start: {
          line: 64,
          column: 2
        },
        end: {
          line: 64,
          column: 22
        }
      }
    },
    fnMap: {
      "0": {
        name: "set",
        decl: {
          start: {
            line: 39,
            column: 16
          },
          end: {
            line: 39,
            column: 19
          }
        },
        loc: {
          start: {
            line: 39,
            column: 89
          },
          end: {
            line: 42,
            column: 1
          }
        },
        line: 39
      },
      "1": {
        name: "setConfig",
        decl: {
          start: {
            line: 44,
            column: 16
          },
          end: {
            line: 44,
            column: 25
          }
        },
        loc: {
          start: {
            line: 44,
            column: 55
          },
          end: {
            line: 48,
            column: 1
          }
        },
        line: 44
      },
      "2": {
        name: "isRTL",
        decl: {
          start: {
            line: 50,
            column: 16
          },
          end: {
            line: 50,
            column: 21
          }
        },
        loc: {
          start: {
            line: 50,
            column: 24
          },
          end: {
            line: 52,
            column: 1
          }
        },
        line: 50
      },
      "3": {
        name: "getDefaultContainer",
        decl: {
          start: {
            line: 54,
            column: 16
          },
          end: {
            line: 54,
            column: 35
          }
        },
        loc: {
          start: {
            line: 54,
            column: 38
          },
          end: {
            line: 65,
            column: 1
          }
        },
        line: 54
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 24,
            column: 13
          },
          end: {
            line: 24,
            column: 46
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 24,
            column: 13
          },
          end: {
            line: 24,
            column: 37
          }
        }, {
          start: {
            line: 24,
            column: 41
          },
          end: {
            line: 24,
            column: 46
          }
        }],
        line: 24
      },
      "1": {
        loc: {
          start: {
            line: 25,
            column: 10
          },
          end: {
            line: 25,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 25,
            column: 10
          },
          end: {
            line: 25,
            column: 31
          }
        }, {
          start: {
            line: 25,
            column: 35
          },
          end: {
            line: 25,
            column: 39
          }
        }],
        line: 25
      },
      "2": {
        loc: {
          start: {
            line: 26,
            column: 10
          },
          end: {
            line: 26,
            column: 52
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 26,
            column: 11
          },
          end: {
            line: 26,
            column: 40
          }
        }, {
          start: {
            line: 26,
            column: 45
          },
          end: {
            line: 26,
            column: 52
          }
        }],
        line: 26
      },
      "3": {
        loc: {
          start: {
            line: 40,
            column: 2
          },
          end: {
            line: 40,
            column: 65
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 40,
            column: 2
          },
          end: {
            line: 40,
            column: 65
          }
        }, {
          start: {
            line: 40,
            column: 2
          },
          end: {
            line: 40,
            column: 65
          }
        }],
        line: 40
      },
      "4": {
        loc: {
          start: {
            line: 40,
            column: 6
          },
          end: {
            line: 40,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 40,
            column: 6
          },
          end: {
            line: 40,
            column: 25
          }
        }, {
          start: {
            line: 40,
            column: 29
          },
          end: {
            line: 40,
            column: 43
          }
        }],
        line: 40
      },
      "5": {
        loc: {
          start: {
            line: 55,
            column: 2
          },
          end: {
            line: 60,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 55,
            column: 2
          },
          end: {
            line: 60,
            column: 3
          }
        }, {
          start: {
            line: 55,
            column: 2
          },
          end: {
            line: 60,
            column: 3
          }
        }],
        line: 55
      },
      "6": {
        loc: {
          start: {
            line: 57,
            column: 4
          },
          end: {
            line: 59,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 57,
            column: 4
          },
          end: {
            line: 59,
            column: 5
          }
        }, {
          start: {
            line: 57,
            column: 4
          },
          end: {
            line: 59,
            column: 5
          }
        }],
        line: 57
      },
      "7": {
        loc: {
          start: {
            line: 62,
            column: 2
          },
          end: {
            line: 62,
            column: 80
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 62,
            column: 2
          },
          end: {
            line: 62,
            column: 80
          }
        }, {
          start: {
            line: 62,
            column: 2
          },
          end: {
            line: 62,
            column: 80
          }
        }],
        line: 62
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _slicedToArray from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { entries } from './utils/objects';
import Notification from './utils/notification';
import { isFunc } from "./utils/is";
export var noti = (cov_1rk3ztyi43.s[0]++, new Notification());
var config = (cov_1rk3ztyi43.s[1]++, {
  cssModule: (cov_1rk3ztyi43.b[0][0]++, !!process.env.CSS_MODULE) || (cov_1rk3ztyi43.b[0][1]++, false),
  prefix: (cov_1rk3ztyi43.b[1][0]++, process.env.SO_PREFIX) || (cov_1rk3ztyi43.b[1][1]++, 'so'),
  locale: (cov_1rk3ztyi43.b[2][0]++, process.env.LOCALE) || (cov_1rk3ztyi43.b[2][1]++, 'en-US'),
  autoSSL: false,
  delay: undefined,
  scrollRatio: 100,
  trim: undefined,
  spin: undefined,
  caret: undefined,
  direction: 'ltr',
  popupContainer: undefined
});
export default config;
export function set(name, value) {
  cov_1rk3ztyi43.f[0]++;
  cov_1rk3ztyi43.s[2]++;

  if ((cov_1rk3ztyi43.b[4][0]++, value !== undefined) && (cov_1rk3ztyi43.b[4][1]++, name in config)) {
    cov_1rk3ztyi43.b[3][0]++;
    cov_1rk3ztyi43.s[3]++;
    config[name] = value;
  } else {
    cov_1rk3ztyi43.b[3][1]++;
  }

  cov_1rk3ztyi43.s[4]++;
  noti.dispatch(name);
}
export function setConfig(conf) {
  cov_1rk3ztyi43.f[1]++;
  cov_1rk3ztyi43.s[5]++;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = entries(conf)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _step$value = _slicedToArray(_step.value, 2),
          key = _step$value[0],
          value = _step$value[1];

      cov_1rk3ztyi43.s[6]++;
      set(key, value);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator["return"] != null) {
        _iterator["return"]();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}
export function isRTL() {
  cov_1rk3ztyi43.f[2]++;
  cov_1rk3ztyi43.s[7]++;
  return config.direction === 'rtl';
}
export function getDefaultContainer() {
  cov_1rk3ztyi43.f[3]++;
  cov_1rk3ztyi43.s[8]++;

  if (isFunc(config.popupContainer)) {
    cov_1rk3ztyi43.b[5][0]++;
    var container = (cov_1rk3ztyi43.s[9]++, config.popupContainer());
    cov_1rk3ztyi43.s[10]++;

    if (container instanceof HTMLElement) {
      cov_1rk3ztyi43.b[6][0]++;
      cov_1rk3ztyi43.s[11]++;
      return container;
    } else {
      cov_1rk3ztyi43.b[6][1]++;
    }
  } else {
    cov_1rk3ztyi43.b[5][1]++;
  }

  cov_1rk3ztyi43.s[12]++;

  if (config.popupContainer instanceof HTMLElement) {
    cov_1rk3ztyi43.b[7][0]++;
    cov_1rk3ztyi43.s[13]++;
    return config.popupContainer;
  } else {
    cov_1rk3ztyi43.b[7][1]++;
  }

  cov_1rk3ztyi43.s[14]++;
  return document.body;
}